import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Header = ({ onOpenModal }) => {
  const location = useLocation();
  const isCorporateTax = location.pathname === '/corporate-tax';

  // State for Corporate Tax sticky header behavior
  const [isStuck, setIsStuck] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    if (!isCorporateTax) return;

    const handleScroll = () => {
      setIsStuck(window.scrollY > 8);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial check

    return () => window.removeEventListener('scroll', handleScroll);
  }, [isCorporateTax]);

  // Variant 1: Corporate Tax Header
  if (isCorporateTax) {
    return (
      <>
        {/* Topbar */}
        <div className="topbar">
          <div className="shell">
            <span>FTA Corporate Tax registration and return filing, Dubai</span>
            <div className="tb-right">

              <a href="tel:+971542119784" style={{ fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'inline-block' }}>
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                +971 54 211 9784
              </a>
            </div>
          </div>
        </div>

        {/* Sticky Site Header */}
        <header className={`site-header ${isStuck ? 'is-stuck' : ''}`} id="siteHeader">
          <div className="shell">
            <nav className="nav" aria-label="Primary" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <a className="brand" href="#top" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                <img
                  src="/standard-auditing-logo-1.png"
                  alt="Standard Auditing"
                  style={{ height: '42px', width: 'auto', display: 'block' }}
                />
              </a>

              <div className="nav-links" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                <a href="#register" style={{ color: 'var(--navy-700)', textDecoration: 'none', fontWeight: 600, fontSize: '.92rem' }}>Do I register?</a>
                <a href="#pricing" style={{ color: 'var(--navy-700)', textDecoration: 'none', fontWeight: 600, fontSize: '.92rem' }}>Cost</a>
                <a href="#process" style={{ color: 'var(--navy-700)', textDecoration: 'none', fontWeight: 600, fontSize: '.92rem' }}>Process</a>
                <a href="#penalties" style={{ color: 'var(--navy-700)', textDecoration: 'none', fontWeight: 600, fontSize: '.92rem' }}>Penalties</a>
                <a href="#faq" style={{ color: 'var(--navy-700)', textDecoration: 'none', fontWeight: 600, fontSize: '.92rem' }}>FAQ</a>
              </div>

              <div className="nav-cta" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>

                <button className="btn js-open-modal" onClick={onOpenModal}>
                  Book a free review
                </button>
                <button
                  className="burger"
                  id="burger"
                  aria-label="Open menu"
                  aria-expanded={isDrawerOpen}
                  aria-controls="drawer"
                  onClick={() => setIsDrawerOpen(true)}
                >
                  <span></span>
                </button>
              </div>
            </nav>
          </div>
        </header>

        {/* Mobile Drawer menu */}
        <div className={`drawer ${isDrawerOpen ? 'is-open' : ''}`} id="drawer" aria-hidden={!isDrawerOpen}>
          <div className="drawer-top">
            <button className="burger" onClick={() => setIsDrawerOpen(false)} aria-label="Close menu" aria-expanded="true">
              <span></span>
            </button>
          </div>
          <a className="d-link" href="#register" onClick={() => setIsDrawerOpen(false)}>Do I have to register?</a>
          <a className="d-link" href="#pricing" onClick={() => setIsDrawerOpen(false)}>What it costs</a>
          <a className="d-link" href="#process" onClick={() => setIsDrawerOpen(false)}>How the process works</a>
          <a className="d-link" href="#penalties" onClick={() => setIsDrawerOpen(false)}>Late penalties</a>
          <a className="d-link" href="#compare" onClick={() => setIsDrawerOpen(false)}>Doing it yourself</a>
          <a className="d-link" href="#about" onClick={() => setIsDrawerOpen(false)}>About Standard Auditing</a>
          <a className="d-link" href="#faq" onClick={() => setIsDrawerOpen(false)}>FAQ</a>
          <button
            className="btn btn--lg"
            onClick={() => {
              setIsDrawerOpen(false);
              onOpenModal();
            }}
            style={{ textTransform: 'none' }}
          >
            Book a free review
          </button>
          <a className="btn btn--ghost btn--lg" href="tel:+971542119784">Call +971 54 211 9784</a>
        </div>
      </>
    );
  }

  // Variant 2: Standard Auditing Home Header
  return (
    <header
      data-screen-label="Header"
      className="home-header"
      style={{
        borderBottom: '1px solid #E4DCCC',
        background: '#FBFAF6',
      }}
    >
      <a href="/" style={{ textDecoration: 'none', display: 'block' }}>
        <img
          src="/standard-auditing-logo-1.png"
          alt="Standard Auditing"
          style={{ height: '42px', width: 'auto', display: 'block' }}
        />
      </a>
      <div
        className="home-header-links"
        style={{
          fontSize: '13.5px',
          fontWeight: 600,
        }}
      >
        <a
          href="tel:+971542119784"
          style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#39362F', textDecoration: 'none' }}
          className="home-header-phone"
        >
          <img
            src="/Phone.webp"
            alt="Phone"
            style={{
              width: '16px',
              height: '16px',
              objectFit: 'contain',
            }}
          />
          <span>+971 54 211 9784</span>
        </a>
        <a
          href="https://wa.me/971542119784"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            background: '#2BAA5E',
            color: '#FBFAF6',
            padding: '10px 20px',
            borderRadius: '8px',
            fontWeight: 700,
            textDecoration: 'none',
            transition: 'background 0.2s',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#23934F';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#2BAA5E';
          }}
        >
          <img
            src="/whatsapp-1.png"
            alt="WhatsApp"
            style={{
              width: '16px',
              height: '16px',
              objectFit: 'contain',
              filter: 'brightness(0) invert(1)',
            }}
          />
          WhatsApp Us
        </a>
      </div>
    </header>
  );
};

export default Header;
